import { createContext } from 'react';

interface StreamChatMessagesContextProps {
  handleChatClick: (memberId?: string, presentingElement?: HTMLElement) => void;
}

export const StreamChatMessagesContext = createContext<StreamChatMessagesContextProps>({
  handleChatClick: () => {},
});
